import React, {useState} from "react";
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';
import {Divider} from "@material-ui/core";
import StandardButton from "components/buttons/StandardButton";
import ICArrowBackIosIcon from "res/images/left_arrow_dark.png";
import ThumbnailGellery from "components/thumbnailGallery/ThumbnailGellery";
import {IsLP_MP_SP_T, IsT} from "my-styles/media/media";
import DialogTitle from "@material-ui/core/DialogTitle";
import messages from "res/messages/farsi";

export default function ModalSliderImage(props) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if(props.openImage){
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (

        <div>

            <div style={{display: "flex", justifyContent: "space-between"}} onClick={handleOpen}>
                {
                    <table className="horizontalFullScreen" style={{marginBottom: '0.1rem', marginTop: '1rem'}}>
                        <tbody>
                        <tr>
                            {
                                props.images && props.images.length>0 && props.images.map((value, index) => {

                                    if (value.length > 0) {
                                        return (
                                            <td key={index}>
                                                <div className="horizontalScreen">
                                                    <img src={value} alt="صرفه مارکت" className="largeIcon"/>
                                                    <div>
                                                        <Divider orientation={"vertical"}/>
                                                    </div>
                                                </div>
                                            </td>
                                        )
                                    }
                                })
                            }

                            {
                                props.images.length > 1 && props.openImage ? (
                                    <td>
                                        <StandardButton
                                            icon={<img src={ICArrowBackIosIcon} alt="صرفه مارکت" className="xxxxSmallIcon"/>}
                                        />
                                    </td>
                                ) : null
                            }
                        </tr>
                        </tbody>
                    </table>

                }
            </div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    <div className="largeTextBold">
                        {messages.CommentsImageList}
                    </div>
                </DialogTitle>
                <DialogContent>
                    {props.images.length > 0 && (
                        <div className="horizontalFullScreen " style={{marginTop: '1rem', width:IsLP_MP_SP_T() ? '30rem' :'20rem'}}>
                            <div className="card   widthResponsiveCardImage marginTopBottomLargeImportant paddingSmall" style={{maxWidth: '85%',overflow:'hidden'}}>
                                <div  style={{marginBottom:'1rem !important'}}>
                                    <ThumbnailGellery
                                        disbledMouse={true}
                                        key={Math.random()}
                                        itemPerView={IsT() ? 3 : 4}
                                        items={props.images}/>
                                </div>
                            </div>
                        </div>
                    )
                    }
                </DialogContent>

            </Dialog>
        </div>
    );

}